import React from 'react'
import {
  ListItem,
  Typography,
  Slider,
  makeStyles,
  withStyles
} from '@material-ui/core'

const useStyles = makeStyles(() => ({
  root: {
    width: '100%'
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'left',
    alignItems: 'flex-start',
    '&.MuiListItem-root': {
      paddingTop: 5,
      paddingBottom: 5,
      color: '#fff',
      fontSize: '11px'
    },
    '&.MuiListItem-gutters': {
      paddingLeft: 12,
      padingRight: 12
    }
  },
  text: {
    '&.MuiTypography-caption': {
      fontSize: '11px'
    }
  }
}))

const CustomSlider = withStyles({
  root: {
    '&.MuiSlider-root': {
      padding: '13px 0'
    }
  }
})(Slider)

type Mark = {
  value: number
  label?: React.ReactNode
}

type Diseases = {
  id: string
  name: string
  min: number
  max: number
  marks: boolean | Mark[]
  step: number
  defaultValue: number
}

interface SliderProps {
  diseases: Diseases[]
  handleChange?: (name: string, value: number) => void
}

const SliderDiseasesSimulation: React.FC<SliderProps> = ({
  diseases,
  handleChange
}) => {
  const classes = useStyles()

  const getValue = (value: number) => {
    return `${value}`
  }

  const change = (name: string, value: number) => {
    if (handleChange) {
      handleChange(name, value)
    }
  }

  return (
    <div className={classes.root}>
      {diseases.map(disease => {
        return (
          <ListItem key={disease.id} className={classes.item}>
            <Typography
              id={disease.name}
              className={classes.text}
              variant="caption"
              color="inherit"
            >
              {disease.name}
            </Typography>
            <CustomSlider
              getAriaValueText={getValue}
              aria-labelledby="discrete-slider"
              valueLabelDisplay="auto"
              marks={disease.marks}
              onChange={(_, value) => {
                change(disease.id, Number(value))
              }}
              id={disease.name}
              defaultValue={disease.defaultValue}
              min={disease.min}
              max={disease.max}
              step={disease.step}
            />
          </ListItem>
        )
      })}
    </div>
  )
}

export default SliderDiseasesSimulation
